export function excludeQueryParams<T extends URLSearchParams>(
  queryParams: T,
  paramKeysToExclude: Set<string>,
) {
  let allowedQueryParams: URLSearchParams | null = null;
  queryParams.forEach((value, key) => {
    if (!paramKeysToExclude.has(key)) {
      if (!allowedQueryParams) {
        // creating new URLSearchParams is not well optimized in browsers yet, therefore we try to avoid it as much as possible
        allowedQueryParams = new URLSearchParams();
      }
      allowedQueryParams.set(key, value);
    }
  });

  if (allowedQueryParams) return allowedQueryParams as T;
  if (queryParams.size !== 0) return new URLSearchParams();
  return queryParams as T;
}
